/* ========================================
   STUDY APARTMENT IMAGES
======================================== */

import study1 from "../assets/study/1.jpeg";
import study2 from "../assets/study/2.jpeg";
import study3 from "../assets/study/3.jpeg";
import study4 from "../assets/study/4.jpeg";
import study5 from "../assets/study/5.jpeg";
import study6 from "../assets/study/6.jpeg";
import study7 from "../assets/study/7.jpeg";


/* ========================================
   STORY APARTMENT IMAGES
======================================== */

import story1 from "../assets/story/1.jpeg";
import story2 from "../assets/story/2.jpeg";
import story3 from "../assets/story/3.jpeg";
import story4 from "../assets/story/4.jpeg";
import story5 from "../assets/story/5.jpeg";
import story6 from "../assets/story/6.jpeg";
import story7 from "../assets/story/7.jpeg";

/* ========================================
   SILVER SCREEN APARTMENT IMAGES
======================================== */

import silverScreen1 from "../assets/silver-screen/1.jpeg";
import silverScreen2 from "../assets/silver-screen/2.jpeg";
import silverScreen3 from "../assets/silver-screen/3.jpeg";
import silverScreen4 from "../assets/silver-screen/4.jpeg";
import silverScreen5 from "../assets/silver-screen/5.jpeg";
import silverScreen6 from "../assets/silver-screen/6.jpeg";
import silverScreen7 from "../assets/silver-screen/7.jpeg";


/* ========================================
   ODEON APARTMENT IMAGES
======================================== */

import odeon1 from "../assets/odeon/1.jpeg";
import odeon2 from "../assets/odeon/2.jpeg";
import odeon3 from "../assets/odeon/3.jpeg";
import odeon4 from "../assets/odeon/4.jpeg";
import odeon5 from "../assets/odeon/5.jpeg";
import odeon6 from "../assets/odeon/6.jpeg";
import odeon7 from "../assets/odeon/7.jpeg";


/* ========================================
   DISCO FLAME APARTMENT IMAGES
======================================== */

import discoFlame1 from "../assets/disco-flame/1.jpeg";
import discoFlame2 from "../assets/disco-flame/2.jpeg";
import discoFlame3 from "../assets/disco-flame/3.jpeg";
import discoFlame4 from "../assets/disco-flame/4.jpeg";
import discoFlame5 from "../assets/disco-flame/5.jpeg";
import discoFlame6 from "../assets/disco-flame/6.jpeg";
import discoFlame7 from "../assets/disco-flame/7.jpeg";


/* ========================================
   APARTMENT DATA
======================================== */

export const apartmentData = [
  {
    id: "study",
    slug: "study-apartment",
    name: "Study Apartment",
    rating: "4.95",
    price: "From ₦300,000 / night",
    details: "3 Bedrooms · Smart automated living",
    description:
      "A refined three-bedroom apartment designed for focused moments, comfort and quiet luxury.",

    features: [
      "Private cinema",
      "Smart automation",
      "High-speed Wi-Fi",
      "24-hour electricity",
      "Professional housekeeping",
      "24-hour security",
    ],

    images: [
      study1,
      study2,
      study3,
      study4,
      study5,
      study6,
      study7,
    ],
  },

  {
    id: "story",
    slug: "story-apartment",
    name: "Story Apartment",
    rating: "4.95",
    price: "From ₦300,000 / night",
    details: "3 Bedrooms · Smart automated living",
    description:
      "A distinctive three-bedroom apartment featuring a private jacuzzi and private terrace.",

    features: [
      "Private jacuzzi",
      "Private terrace",
      "Smart automation",
      "High-speed Wi-Fi",
      "24-hour electricity",
      "Professional housekeeping",
    ],

    images: [
      story1,
      story2,
      story3,
      story4,
      story5,
      story6,
      story7,
    ],
  },

  {
    id: "silver-screen",
    slug: "silver-screen-apartment",
    name: "Silver Screen Apartment",
    rating: "4.95",
    price: "From ₦300,000 / night",
    details: "3 Bedrooms · Smart automated living",
    description:
      "A sophisticated three-bedroom apartment with a private cinema experience.",

    features: [
      "Private cinema",
      "Smart automation",
      "High-speed Wi-Fi",
      "24-hour electricity",
      "Dedicated parking",
      "Professional housekeeping",
    ],

    images: [
      silverScreen1,
      silverScreen2,
      silverScreen3,
      silverScreen4,
      silverScreen5,
      silverScreen6,
      silverScreen7,
    ],
  },

  {
    id: "odeon",
    slug: "odeon-apartment",
    name: "Odeon Apartment",
    rating: "4.95",
    price: "From ₦300,000 / night",
    details: "3 Bedrooms · Smart automated living",
    description:
      "A beautifully appointed three-bedroom residence featuring an immersive private cinema.",

    features: [
      "Private cinema",
      "Smart automation",
      "High-speed Wi-Fi",
      "24-hour electricity",
      "24-hour security",
      "Dedicated parking",
    ],

    images: [
      odeon1,
      odeon2,
      odeon3,
      odeon4,
      odeon5,
      odeon6,
      odeon7,
    ],
  },

  {
    id: "disco-flame",
    slug: "disco-flame-apartment",
    name: "Disco Flame Apartment",
    rating: "4.95",
    price: "From ₦300,000 / night",
    details: "3 Bedrooms · Smart automated living",
    description:
      "A bold three-bedroom apartment with a private cinema and exclusive private bar.",

    features: [
      "Private cinema",
      "Private bar",
      "Smart automation",
      "High-speed Wi-Fi",
      "24-hour electricity",
      "Professional housekeeping",
    ],

    images: [
      discoFlame1,
      discoFlame2,
      discoFlame3,
      discoFlame4,
      discoFlame5,
      discoFlame6,
      discoFlame7,
    ],
  },
];

/* Used for apartment filter pills. */
export const apartmentPills = [
  {
    id: "all",
    label: "All Apartments",
  },

  ...apartmentData.map((apartment) => ({
    id: apartment.id,
    label: apartment.name,
  })),
];

/* Optional helper function for future apartment detail pages. */
export const getApartmentById = (id) =>
  apartmentData.find((apartment) => apartment.id === id);

export default apartmentData;
